
// Revenue unit is billion (bn)
// Source based on : Statista

export const SodaData = [
    {
        year: 2016,
        totalRevenue: {
            pepsi: 62.8,
            cola: 41.9
        },
        drinkRevenue: {
            pepsi: 30.3,
            cola: 41.9
        },
        snackRevenue: {
            pepsi: 32.5,
            cola: 0
        },
        drinkMarketSahre: {
            pepsi: 0.268,
            cola: 0.441,
            peper: 0.194,
            others: 0.097
        }
    },{
        year: 2017,
        totalRevenue: {
            pepsi: 63.5,
            cola: 35.4
        },
        drinkRevenue: {
            pepsi: 30.4,
            cola: 35.4
        },
        snackRevenue: {
            pepsi: 33.2,
            cola: 0
        },
        drinkMarketSahre: {
            pepsi: 0.266,
            cola: 0.448,
            peper: 0.20,
            others: 0.086
        }
    },{
        year: 2018,
        totalRevenue: {
            pepsi: 64.7,
            cola: 31.9
        },
        drinkRevenue: {
            pepsi: 30.7,
            cola: 31.9
        },
        snackRevenue: {
            pepsi: 33.9,
            cola: 0
        },
        drinkMarketSahre: {
            pepsi: 0.261,
            cola: 0.453,
            peper: 0.198,
            others: 0.088
        }
    },{
        year: 2019,
        totalRevenue: {
            pepsi: 66.6,
            cola: 37.0
        },
        drinkRevenue: {
            pepsi: 33.3,
            cola: 37.0
        },
        snackRevenue: {
            pepsi: 33.3,
            cola: 0
        },
        drinkMarketSahre: {
            pepsi: 0.257,
            cola: 0.460,
            peper: 0.198,
            others: 0.085
        }
    },{
        year: 2020,
        totalRevenue: {
            pepsi: 68.6,
            cola: 38.9
        },
        drinkRevenue: {
            pepsi: 34.3,
            cola: 38.9
        },
        snackRevenue: {
            pepsi: 34.3,
            cola: 0
        },
        drinkMarketSahre: [
            0.259,
            0.449,
            0.211,
            0.081
        ]
    }
]